import React, { useEffect, useState } from "react";
import { ActivityIndicator, Modal, StyleSheet, Text, View } from "react-native"
import { convertBase64ToBinary, convertPathToBase64 } from "../../../js/parseImageData/parseImageData";
import { ID_BACK, ID_FRONT } from "./verifyIdentity";
import { isIOS } from '../../../utils/Helper';
import AsyncStorage from "@react-native-async-storage/async-storage";
import { CustomModal } from "../../../components/customModal";
import CustomPressable from "../../../components/customPressable/customPressable";
import { useCssStyle } from "../../../customHook/getCssStyle";
import { ProgressBarModal } from "../../../components/progressBarModal";
import InfoPopupModal from "../../../components/infoPopupModal";
import { useTranslation } from "react-i18next";
import { MOBILE_CHECKIN_CATEGORY } from "../../../config/Constant";
import { useDispatch, useSelector } from "react-redux";
import { sendAnalytics } from "../../../Redux/Actions/analyticsAction";

export const ValidateConfidence = (props) => {

    const getStyles = useCssStyle();
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const {checkinSessionToken, lastName, disableLivelinessCheck, selectedIdType, idVerificationLocalMediaFiles, handleIdResponseError, handleLivelinessError, handleClose, handleNext } = props;

    const { webAppWidgetsInfo } = useSelector(state => state.deviceConfigSlice);
    const { innspireOneConfigs } = useSelector((state) => state.appPreservedConfigSlice);
    const INNSPIREONE_API_KEY = innspireOneConfigs?.api_key;
    const INNSPIREONE_BASE_URL = innspireOneConfigs?.api_url;

    const { confidenceScores: configuredConfidenceScores } = webAppWidgetsInfo.mobileCheckInConfigs || {};

    const [progressBar, setProgressBar] = useState(0);

    const [startVerification, setStartVerification] = useState(false);
    const [parsedIdVerificationLocalMediaFiles, setParsedIdVerificationLocalMediaFiles] = useState({
        selectedIdType: {},
        idImageUri: "",
        idImageBackUri: "",
        idImagesInfo: {},
        selfieUri: "",
        selfieFiles: []
    });

    const [verificationSuccess, setVerificationSuccess] = useState({
        idImageFrontStatus: false,
        idImageBackStatus: false,
        selfieStatus: false

    })

    const [errorStatus, setErrorStatus] = useState({
        isError: false,
        errorMessage: ""
    })


    const [showProgressModal, setShowProgressModal] = useState(false);
    const [showErrorModal, setShowErrorModal] = useState(false);


    const ml_headers = {
        "x-api-key": "VUsa50QUiY6PNSgZ1vPCE1iDhX5PVETMu4SFwb4c",
        "x-app-name": "guest-journey",
        "Content-Type": "application/json"
    };

    const innspireone_header = {
        "Content-Type": "application/json",
        "Authorization": `${INNSPIREONE_API_KEY}`
    }


    const updateProgressBar = (increment) => setProgressBar((prev) => prev + increment);
    const updateVerificationStatus = (keyValueObj) => setVerificationSuccess((prev) => ({ ...prev, ...keyValueObj }));

    const handleIdVerification = () => {


        const handleParseIdError = (errorMessage) => {
            setErrorStatus({ isError: true, errorMessage: errorMessage });
            handleIdResponseError();
        }

        const handleIdImagesInfo = (idCardResponse, imageSide) => {
            console.log("in handleIdImagesInfo");
            console.log(idCardResponse);

            const prevResponse = { ...parsedIdVerificationLocalMediaFiles.idImagesInfo };
        
            // Ensure fields array exists in both responses
            prevResponse.fields = prevResponse.fields || [];
        
            for (const key in idCardResponse) {
                if (key === "type" && (imageSide == ID_FRONT)) {
                    prevResponse[key] = idCardResponse[key];
                } else if (key === "raw_text") {
                    prevResponse[key] = (prevResponse[key] || "") + idCardResponse[key];
                } else if (key === "fields") {
                    const secondFields = idCardResponse[key];
                    secondFields.forEach(secondResponseField => {
                        prevResponse[key].push(secondResponseField);
                    });
                }
            }
        
            console.log("mergedResponse", prevResponse);
            setParsedIdVerificationLocalMediaFiles({ 
                ...parsedIdVerificationLocalMediaFiles, 
                idImagesInfo: prevResponse 
            });
        };

        const parseIdCard = async (imageUri, imageSide, idType, ocrText) => {
            const updatedImageUri = imageUri.replace("data:image/jpeg;base64,", "");

            try {
                const response = await fetch(`${INNSPIREONE_BASE_URL}ai-services/classify-id-card/`, {
                    method: 'POST',
                    body: JSON.stringify({
                        idcard_image: updatedImageUri,
                        ocr_text: ocrText,
                        page: imageSide,
                        type: idType
                    }),
                    headers: innspireone_header,
                });


                const data = await response.json();

                if (!response.ok) {
                    handleParseIdError(data?.detail || "Something went wrong");
                    dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "ID VERIFICATION - FAILED", { "element": "widget", "widgetSessionId": checkinSessionToken, "idType": idType, "imageSide": imageSide, "errorMessage": data?.detail || "Something went wrong during validating ID" }));
                    return;
                } else {
                    console.log(`parseIdCard API response: when ${imageSide} side is processed`);


                    handleIdImagesInfo(data, imageSide);

                    updateVerificationStatus(imageSide == ID_BACK ? { idImageBackStatus: true } : { idImageFrontStatus: true });
                    setTimeout(() => {
                        updateProgressBar(18);
                    }, 0);

                    dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "ID VERIFICATION - SUCCESS", { "element": "widget", "widgetSessionId": checkinSessionToken, "idType": idType, "imageSide": imageSide }));
                }
            } catch (error) {
                console.log("parseIdCard API response failed:", error);
                dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "ID VERIFICATION - FAILED", { "element": "widget", "widgetSessionId": checkinSessionToken, "idType": idType, "imageSide": imageSide, "errorMessage": error?.response?.data?.detail || "Something went wrong during validating ID" }));
                handleParseIdError(error?.response?.data?.detail || "Something went wrong");
            }
        };


        // const extractTextsFromId = async (imageUri, imageSide, idType) => {
        //     console.log("imageUri", imageUri);

        //     const requestBody = {
        //         requests: [{
        //             image: {
        //                 content: imageUri.replace("data:image/jpeg;base64,", "")
        //             },
        //             features: [{ type: "TEXT_DETECTION" }],
        //             imageContext: { languageHints: ["en"] }
        //         }]
        //     };

        //     try {
        //         const response = await fetch("https://vision.googleapis.com/v1/images:annotate/?key=AIzaSyAFwpDICdlbldOY4tQQRJQkAetrbYMz2NA", {
        //             method: 'POST',
        //             body: JSON.stringify(requestBody),
        //             headers: { "Content-Type": "application/json" },
        //         });

        //         const data = await response.json();

        //         if (!response.ok) {
        //             console.log("OCR response error:", data);
        //             parseIdCard(imageUri, imageSide, idType, "");
        //         } else {
        //             const ocrTexts = data.responses?.[0]?.fullTextAnnotation?.text || '';
        //             parseIdCard(imageUri, imageSide, idType, ocrTexts);
        //         }
        //     } catch (error) {
        //         console.log("OCR response error: ", error);
        //         parseIdCard(imageUri, imageSide, idType, '');
        //     }
        // };


        if (selectedIdType.bothSideImageRequired) {
            parseIdCard(parsedIdVerificationLocalMediaFiles.idImageUri, ID_FRONT, selectedIdType.key)
            parseIdCard(parsedIdVerificationLocalMediaFiles.idImageBackUri, ID_BACK, selectedIdType.key)
        } else {
            updateVerificationStatus({ idImageBackStatus: true });
            setTimeout(() => {
                updateProgressBar(18);
            }, 0);
            parseIdCard(parsedIdVerificationLocalMediaFiles.idImageUri, ID_FRONT, selectedIdType.key)
        }
    }


    const handleLivelinessCheck = async () => {

        let sessionToken = await AsyncStorage.getItem('sessionToken');

        let selfiFilesUri = [];

        const handleLivlinessDetectionError = (errorMessage) => {
            setErrorStatus({ isError: true, errorMessage: errorMessage });
            handleLivelinessError();
        }

        const parseMultiShotSelfie = () => {

            const imageUri = parsedIdVerificationLocalMediaFiles.idImageUri;
            const updatedImageUri = imageUri.replace("data:image/jpeg;base64,", "");

            setTimeout(async () => {
                try {
                    const response = await fetch("https://ilm64dzzu4.execute-api.us-east-1.amazonaws.com/Production/guest-journey/verify-face-with-multishot/", {
                        method: 'POST',
                        headers: ml_headers,
                        body: JSON.stringify({
                            idcard_image: updatedImageUri,
                            selfie_key: selfiFilesUri
                        })
                    });

                    const data = await response.json();

                    if (!response.ok) {
                        handleLivlinessDetectionError(data.detail || data.message);
                        dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "ID CONFIDENCE VERIFICATION - FAILED", { "element": "widget", "widgetSessionId": checkinSessionToken, "errorMessage":data.detail || data.message || "Something went wrong during validating liviness" }));
                    } else {                        

                        if(data.selfie.match < configuredConfidenceScores.guestPhotoMatching){
                            handleLivlinessDetectionError(t('check_in.id_verification.low_confidence_facematch'));
                            handleIdResponseError();

                            dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "ID CONFIDENCE VERIFICATION - FAILED", { "element": "widget", "widgetSessionId": checkinSessionToken, "errorMessage": `LOW CONFIDENCE SELFIE LIVELINESS SCORE: ${data.selfie.match}`, "scoreValueLiveness": data.selfie.match, "valueSetFromCMSAsMinimumValueForLiveness": configuredConfidenceScores.guestPhotoMatching }));
                            return;
                        }

                        if(data.selfie.live < configuredConfidenceScores.guestSelfieLiveliness){
                            handleLivlinessDetectionError(t('check_in.id_verification.liveness_failed'));

                            dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "ID CONFIDENCE VERIFICATION - FAILED", { "element": "widget", "widgetSessionId": checkinSessionToken, "errorMessage": `LOW CONFIDENCE PHOTO MATCHING SCORE: ${data.selfie.live}`, "scoreValuePhoto": data.selfie.live, "valueSetFromCMSAsMinimumValueForPhoto": configuredConfidenceScores.guestSelfieLiveliness }));
                            return;
                        }

                        dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "ID CONFIDENCE VERIFICATION - SUCCESS", { "element": "widget", "widgetSessionId": checkinSessionToken, "scoreValueLiveness": data.selfie.match, "valueSetFromCMSAsMinimumValueForLiveness": configuredConfidenceScores.guestPhotoMatching, "scoreValuePhoto": data.selfie.live, "valueSetFromCMSAsMinimumValueForPhoto": configuredConfidenceScores.guestSelfieLiveliness }));
                        updateVerificationStatus({ selfieStatus: true });
                        setTimeout(() => {
                            updateProgressBar(23);
                        }, 0);
                        console.log("parseMultiShotSelfi API response sucess");
                    }
                } catch (error) {
                    console.log("error while parsing mutishot selfie: ", error)
                    handleLivlinessDetectionError(error.message);
                    dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "ID CONFIDENCE VERIFICATION - FAILED", { "element": "widget", "widgetSessionId": checkinSessionToken, "errorMessage": error?.message || "Something went wrong during validating liviness" }));
                }
            }, 1000);
        }


        const getUri = async (file, fileFormat, presignedData) => {
            const response = await fetch(presignedData.url, {
                method: 'PUT',
                headers: {
                    "Content-Type": `image/${fileFormat}`
                },
                body: file
            });

            if (!response.ok) throw new Error("Upload failed");
        };

        const fetchPreSignedURL = async (key, format) => {
            const response = await fetch("https://ilm64dzzu4.execute-api.us-east-1.amazonaws.com/Production/guest-journey/get-upload-url", {
                method: 'POST',
                headers: ml_headers,
                body: JSON.stringify({
                    file_name: key,
                    ContentType: `image/${format}`
                })
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(`Error while getting presigned URL: ${data.detail}`);
            }
            return data;
        };

        const getSelfiFilesUri = async (uri) => {
            const key = `checkin/${sessionToken}/${Math.floor(Math.random() * 1000)}.jpeg`;
            const isBase64 = uri.startsWith("data:image/") || uri.startsWith("data:application/") && uri.includes("base64,")
            const fileFormat = isBase64 ? uri.slice(uri.indexOf("/") + 1, uri.indexOf(";")) : uri.split(".").pop();

            try {
                const presignedData = await fetchPreSignedURL(key, fileFormat);
                const binaryImageData = convertBase64ToBinary(uri);

                await getUri(binaryImageData, fileFormat, presignedData);
                selfiFilesUri.push(key);
                console.log("Uploaded successfully");


            } catch (error) {
                console.log("error while uploading selfi uri: ", error)
            }
        }


        try {
            await Promise.all(parsedIdVerificationLocalMediaFiles.selfieFiles.map(getSelfiFilesUri));
            parseMultiShotSelfie();
        } catch (error) {
            handleLivlinessDetectionError(error.message || "Error in processing liveliness check");
        }
    }


    const initializeVerification = () => {

        if (disableLivelinessCheck) {
            updateVerificationStatus({ selfieStatus: true });

            setTimeout(() => {
                updateProgressBar(23)
            }, 0);
            handleIdVerification();
        } else {
            handleIdVerification();
            handleLivelinessCheck();
        }
    }

    const initializeParsingImageData = async () => {
        const updatedFiles = { ...idVerificationLocalMediaFiles };

        // Convert each URI to Base64 if it's not already in base64 format
        updatedFiles.idImageUri = await convertPathToBase64(idVerificationLocalMediaFiles.idImageUri);
        updatedFiles.idImageBackUri = await convertPathToBase64(idVerificationLocalMediaFiles.idImageBackUri);

        updatedFiles.idImagesInfo = {};

        updatedFiles.selfieUri = await convertPathToBase64(idVerificationLocalMediaFiles.selfieUri);
        // Optionally handle selfieFiles if needed
        updatedFiles.selfieFiles = await Promise.all(
            idVerificationLocalMediaFiles.selfieFiles.map(async (uri) =>
                await convertPathToBase64(uri)
            )
        );
        setParsedIdVerificationLocalMediaFiles(updatedFiles);
        updateProgressBar(5)

        setStartVerification(true);
    }

    useEffect(() => {
        if (startVerification) initializeVerification();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startVerification])

    useEffect(() => {
        setShowProgressModal(true);
        setProgressBar(40)
        initializeParsingImageData();

        const progressBarInterval = setInterval(() => {
            setProgressBar((prevValue) => {
                if (prevValue >= 100 || errorStatus.isError) {
                    clearInterval(progressBarInterval);
                    return 100;
                }
                return prevValue + 1;
            });
        }, 2000);

        dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "VERIFYING YOUR IDENTITY", { "element": "widget", "widgetSessionId": checkinSessionToken}));


        return () => {
            clearInterval(progressBarInterval);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    useEffect(() => {

        if (errorStatus.isError) {
            setShowProgressModal(false);

            setTimeout(() => {
                setShowErrorModal(true)
            }, 10);
        }

        if (!errorStatus.isError) {
            setShowErrorModal(false);

            setTimeout(() => {
                setShowProgressModal(true);
            }, 10);
        }

    }, [errorStatus.isError])


    const handleGoBack = () => {
        handleClose();
    }

    useEffect(() => {
        if (progressBar >= 100 && !(verificationSuccess.idImageFrontStatus && verificationSuccess.idImageBackStatus && verificationSuccess.selfieStatus)) {

            if(!verificationSuccess.selfieStatus){
                dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "ID CONFIDENCE VERIFICATION - TIMEOUT", { "element": "widget", "widgetSessionId": checkinSessionToken, "errorMessage": "Request Timeout" }));
                return;
            }

            if(!verificationSuccess.idImageFrontStatus && !verificationSuccess.idImageBackStatus){
                dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "ID VERIFICATION - TIMEOUT", { "element": "widget", "widgetSessionId": checkinSessionToken, "errorMessage": "Request Timeout" }));
                return;
            }

            setErrorStatus({ isError: true, errorMessage: t('check_in.id_verification.request_timeout') });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [progressBar])

    useEffect(() => {

        if (errorStatus.isError && verificationSuccess.idImageFrontStatus && verificationSuccess.idImageBackStatus) {

            if(!parsedIdVerificationLocalMediaFiles.idImagesInfo || Object.keys(parsedIdVerificationLocalMediaFiles.idImagesInfo).length == 0 || !parsedIdVerificationLocalMediaFiles.idImagesInfo.type || !parsedIdVerificationLocalMediaFiles.idImagesInfo.type.confidence < configuredConfidenceScores.guestIDValidation){
                setErrorStatus({ isError: true, errorMessage: t('check_in.id_verification.low_confidence_id') });
                dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "ID VERIFICATION - FAILED", { "element": "widget", "widgetSessionId": checkinSessionToken, "errorMessage": "Low confidence in provided ID.", "scoreValueID": parsedIdVerificationLocalMediaFiles.idImagesInfo.type.confidence, "valueSetFromCMSAsMinimumValueForID": configuredConfidenceScores.guestIDValidation }));
                handleIdResponseError();
                return;
            }

            console.log(lastName);
            if(!parsedIdVerificationLocalMediaFiles.idImagesInfo || Object.keys(parsedIdVerificationLocalMediaFiles.idImagesInfo).length == 0 || !parsedIdVerificationLocalMediaFiles.idImagesInfo.raw_text || !parsedIdVerificationLocalMediaFiles.idImagesInfo.raw_text.toLowerCase().includes(lastName.trim().toLowerCase())){
                setErrorStatus({ isError: true, errorMessage: t('check_in.id_verification.last_name_mismatch') });
                dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "ID VERIFICATION - FAILED", { "element": "widget", "widgetSessionId": checkinSessionToken, "errorMessage": "The last name on the ID does not match the booking last name." }));
                handleIdResponseError();
                return;
            }
        }

        if (!errorStatus.isError && verificationSuccess.idImageFrontStatus && verificationSuccess.idImageBackStatus && verificationSuccess.selfieStatus) {
            handleNext(parsedIdVerificationLocalMediaFiles.idImagesInfo);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [verificationSuccess])

    return (
        <>
            {showErrorModal && <InfoPopupModal subtitle={errorStatus.errorMessage} onContinue={handleGoBack} primaryBtnLabel={"Try again"} OnRequestClose={handleGoBack} />}
            {showProgressModal &&
                <ProgressBarModal
                    heading={t('check_in.id_verification.primary_button_active')}
                    progressPercentage={progressBar}
                />
            }
        </>
    )
}